import { motion } from 'framer-motion'
import React from 'react'
import { Container } from 'react-bootstrap'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'

export default function Events() {
    return (
      <motion.div 
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Events" />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
        <PageWrapper name={'Events'} display={<h1 className="txt-big">Events</h1>}>
          <span className="txt-cream txt-shadow">Group transport for weddings, festivals, and corporate gatherings in Jamaica.</span>
        </PageWrapper>
        <Container className="text-cream mb-5" style={{ maxWidth: '70ch' }}>
          <p>
            Reggae Wheels can move guests between venues along the north coast — from Discovery Bay and Ocho Rios
            to Montego Bay event spaces.
          </p>
          <p>Reach out through About Us to plan shuttles for your event date.</p>
        </Container>
        <Footer></Footer>
      </motion.div>
      )
}
